export default __webpack_public_path__ + "static/illustration-business.url-a3e774926761bd97ad557bb209a11cf6.svg";